import actionCreator from "helpers/actionCreator"
import { createReducer } from "reduxsauce"

export const { Types, Creators } = actionCreator("ompnt/modules/tag-and-attributes-creator", {
  createTagsOrAttributesStart: {
    props: ["tags", "attributes"],
  },
  createTagsOrAttributesSuccess: {},
  createTagsOrAttributesCancel: {},
  createTagsOrAttributesError: {},
})

const DEFAULT_STATE = {
  visible: false,
  mode: "dialog",
  tags: undefined,
  attributes: undefined,
}

function handleCreateTagsOrAttributesStart(state, { tags, attributes }) {
  return {
    ...state,
    visible: true,
    tags,
    attributes,
  }
}

function handleSetInvisible(state) {
  return { ...state, visible: false }
}

export default createReducer(DEFAULT_STATE, {
  [Types.CREATE_TAGS_OR_ATTRIBUTES_START]: handleCreateTagsOrAttributesStart,
  [Types.CREATE_TAGS_OR_ATTRIBUTES_SUCCESS]: handleSetInvisible,
  [Types.CREATE_TAGS_OR_ATTRIBUTES_ERROR]: handleSetInvisible,
  [Types.CREATE_TAGS_OR_ATTRIBUTES_CANCEL]: handleSetInvisible,
})
